import { useCallback, useContext, useState } from 'react'

import { Visibility } from 'globalTypes'

import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/App/Button'
import { Context as ShareContext } from 'Root/Contexts/Share'
import { isMatching } from 'lib/breakpoint-helper'
import {
  attachTokenInviteToLink,
  copyShareLink,
  fixUrl,
} from 'lib/share-callback'

const canUseNavigatorShare = Boolean(
  typeof window !== 'undefined' &&
    window.navigator.share &&
    window.navigator.canShare
)

const GenerateLink = ({ visibility }: { visibility: Visibility }) => {
  const { i18n } = useLingui()
  const shareData = useContext(ShareContext)
  const isMobile = isMatching('sm', true)
  const [generateLink, setGenerateShareLink] = useState('')
  const allowCopy = visibility === Visibility.public || generateLink.length > 0

  const handleCopyLink = copyShareLink(
    canUseNavigatorShare && isMobile && window.navigator.canShare(shareData),
    shareData,
    visibility === Visibility.public ? shareData.url : generateLink,
    i18n
  )

  const fetchTokenInviteLink = useCallback(async () => {
    const data = await attachTokenInviteToLink(shareData)

    setGenerateShareLink(fixUrl(data))
  }, [shareData])

  return (
    <span id="generate-link" className="flex flex-col gap-1 sm:flex-row">
      <span className="w-full px-3 py-5 text-gray-400 border-gray-300 rounded-md shadow-sm form-input">
        {visibility === Visibility.public
          ? fixUrl(shareData.url)
          : generateLink}
      </span>
      <span className="inline-flex gap-1 items-center">
        <Button
          className="w-max bg-gray-100 text-gray-400"
          onClick={handleCopyLink}
          style={{ minHeight: '3.5rem' }}
          disabled={!allowCopy}
        >
          <Trans>Copia link</Trans>
        </Button>

        {visibility != Visibility.public && (
          <Button
            className="w-max"
            style={{ minHeight: '3.5rem' }}
            onClick={fetchTokenInviteLink}
          >
            <Trans>Genera link</Trans>
          </Button>
        )}
      </span>
    </span>
  )
}

export default GenerateLink
